import React, { ReactElement } from 'react';

const Map: React.FC = (): ReactElement => {
  return (
    <iframe
      title="NovaLogo map"
      width="100%"
      height="370"
      frameBorder="0"
      scrolling="yes"
      src="https://maps.google.com/maps?width=100%25&amp;height=370&amp;hl=en&amp;q=Timisoara%20Str%20Cozia%20nr%2036+(Nova%20Logo)&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
    />
  );
};

export default Map;
